import * as yup from 'yup';

const productSchema = yup.object().shape({
  productName: yup.string().required('Product name is required'),
  productNameBn: yup.string(),
  category: yup.string().required('Category is required'),
  subCategory: yup.string(),
  barcode: yup.string(),
  purchasePrice: yup.number().typeError('Must be a number').positive('Must be positive'),
  sellingPrice: yup.number()
    .typeError('Must be a number')
    .positive('Must be positive')
    .required('Selling price is required'),
  quantity: yup.number().typeError('Must be a number').integer('Must be integer').min(0),
  unit: yup.string(),
  minStockLevel: yup.number().typeError('Must be a number').integer('Must be integer').min(0),
  description: yup.string(),
  image: yup.mixed(),
});

export default productSchema;
